import {IApiEndpoint, IPagination,} from "@localization/siteMap/siteMapInterfaces.ts";
import {siteMapApi} from "@localization/siteMap/siteMap.ts";
import type {INotificacao} from "@models/conta/notificacao.js";
import type {GetMinhasNotificacoesFilter, INotificacaoAlterarStatusDto} from "@models/conta/notificacaoDto.js";
import type {IUsuario} from "@models/conta/IUsuario.js";
import type {IRole} from "@models/roles/roles.js";
import {IUsuarioFiltersDto} from "@models/conta/IUsuarioFiltersDto.ts";
import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IGetUsuarioFilter} from "@components/usuario/dto/request/IGetUsuarioFilter.ts";
import {ICreateUsuarioDto} from "@components/usuario/dto/input/ICreateUsuarioDto.ts";
import {ILog} from "@models/seguranca/ILog.ts";

export const __usuarios_endpoints = {
    getContasPesquisa: (search: string, pagination: IPagination): IApiEndpoint => ({
        url: '/api/Conta/GetContasPesquisa',
        pagination: pagination,
        query: {search: search},
        method: "GET"
    }),
    getMinhasNotificacoesSocket: (dto: GetMinhasNotificacoesFilter, pagination: IPagination): IApiEndpoint => ({
        url: '/ws/minhas-notificacoes',
        pagination: pagination,
        query: dto,
        method: "GET",
        webSocket: true
    }),
    GetMinhasNotificacoes: (dto: GetMinhasNotificacoesFilter, pagination: IPagination): IApiEndpoint<INotificacao[]> => ({
        url: '/api/Conta/GetMinhasNotificacoes',
        pagination: pagination,
        query: dto,
        method: "GET"
    }),
    alterarStatusNotificacao: (notificacao: INotificacaoAlterarStatusDto): IApiEndpoint => ({
        url: '/api/Conta/ChangeNotificationStatus',
        body: notificacao,
        method: "PATCH"
    }),
    getRolesPesquisa: (search: string, pagination: IPagination): IApiEndpoint => ({
        url: '/api/Conta/GetRolesPesquisa',
        pagination: pagination,
        query: {search: search},
        method: "GET"
    }),
    GetContas: (dto: IUsuarioFiltersDto, pagination: IPagination): IApiEndpoint<IUsuario[]> => ({
        url: '/api/Conta/GetContas',
        query: dto,
        pagination,
        method: "GET"
    }),
    ['ImportUsuarios']: (data: IDataNoPageDto<IUsuario[]>): IApiEndpoint => ({
        url: '/api/Conta/ImportUsuarios',
        data: data,
        method: "POST"
    }),
    ['GetRoles']: (filters: IGetRolesFilter, pagination: IPagination): IApiEndpoint<IRole[]> => ({
        url: '/api/Conta/GetRoles',
        query: filters,
        pagination,
        method: "GET"
    }),
    ['v2']: {
        ['get-usuarios']: (data: IDataDto<IGetUsuarioFilter>): IApiEndpoint<IUsuario[]> => ({
            url: '/api/v2/Usuarios',
            data: data,
            method: "GET"
        }),
        ['get-logs']: (data: IDataDto<{ usuarioId: number }>): IApiEndpoint<ILog[]> => {
            return ({
                url: `/api/v2/Usuarios/${data.data.usuarioId}/logs`,
                data: {...data, data: {}},
                method: "GET"
            });
        },
        ['minhas-notificacoes']: (data: IDataDto<GetMinhasNotificacoesFilter>): IApiEndpoint<INotificacao[]> => ({
            url: '/api/v2/Usuarios/MinhasNotificacoes',
            data: data,
            method: "GET"
        }),
        ['create-usuario']: (data: IDataNoPageDto<ICreateUsuarioDto>): IApiEndpoint<IUsuario> => ({
            url: '/api/v2/Usuarios',
            data: data,
            method: "POST"
        }),
        ['purge-cache']: (): IApiEndpoint => ({
            url: '/api/v2/Usuarios/Purge-Cache',
            method: 'DELETE'
        })
    },

}


export const AlterarStatusNotificacao = async (notificacao: INotificacaoAlterarStatusDto) => {
    const endpoint = __usuarios_endpoints.alterarStatusNotificacao(notificacao);

    return await siteMapApi.request<INotificacao>(endpoint)
}
